
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import { SmileySizes, SmileyTypes } from '@/components/svg-components/Smiley.vue';
import MyRecommendations from '@/views/recommendations/components/my-recommendations/MyRecommendations.vue';
import RecommendationsForMe from '@/views/recommendations/components/recommendations-for-me/RecommendationsForMe.vue';
import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import useUser from '@/mixins/useUser';

export default defineComponent({
  name: 'Recommendations',
  components: {
    RecommendationsForMe,
    MyRecommendations,
    BCXBreadcrumbs,
    BCXContentArea,
  },
  setup() {
    const { tUserFallback: t } = useUser('self');
    const store = useStore();
    const isMobileLayout = computed(() => store.getters['page/isMobileLayout']);
    const smileyChoice = ref('');

    const breadcrumbItems = computed(() => {
      const breadcrumbItems: Array<any> = [
        { text: t('project-forum_USERTYPE.labels.projects'), to: { name: 'projectList' } },
        { text: t('recommendations.recommendations.title'), to: { name: 'recommendations' } },
      ];
      if (isMobileLayout.value) { // display logo as first item
        breadcrumbItems.unshift({ text: 'ByteCookie' });
      }
      return breadcrumbItems;
    });

    return {
      t,
      breadcrumbItems,
      SmileySizes,
      SmileyTypes,
      smileyChoice,
    };
  }
});
